<template>
  <section class="co-surface co-heatmap">
    <div class="co-heatmap__head mb-3">
      <h2 class="co-section-title">
        Mapa de calor — atendimentos
      </h2>
      <p class="co-heatmap__desc mb-0">
        Quantidade de atendimentos por dia e hora de início, no mesmo período do gráfico acima.
      </p>
    </div>
    <div
      v-if="loading"
      class="text-center py-4 text-muted"
    >
      <b-spinner
        small
        class="mr-2"
      />
      Carregando mapa…
    </div>
    <div
      v-else-if="!series.length"
      class="text-center py-4 text-muted"
    >
      Nenhum atendimento no período para montar o heatmap.
    </div>
    <div
      v-else
      class="co-heatmap__chart"
    >
      <vue-apex-chart
        type="heatmap"
        :height="chartHeight"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </section>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { buildHeatmapAtendimentosSeries, buildHeatmapApexOptions } from './operacao-central-utils'

export default {
  name: 'CentralHeatmapAtendimentosSection',
  components: {
    'vue-apex-chart': VueApexCharts,
  },
  props: {
    atendimentos: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
    }
  },
  computed: {
    series() {
      return buildHeatmapAtendimentosSeries(this.atendimentos, 'inicio')
    },
    chartOptions() {
      return buildHeatmapApexOptions(this.series, 'oc-heatmap-atend', this.windowWidth < 768)
    },
    chartHeight() {
      if (this.windowWidth < 576) return 240
      if (this.windowWidth < 768) return 300
      const rows = Math.max(1, this.series.length)
      return Math.min(520, 120 + rows * 36)
    },
  },
  mounted() {
    this.onResize = () => {
      this.windowWidth = window.innerWidth
    }
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    if (this.onResize) {
      window.removeEventListener('resize', this.onResize)
    }
  },
}
</script>

<style scoped>
.co-surface {
  background: #faf8fc;
  border-radius: 24px;
  padding: 1.75rem 1.5rem 1.25rem;
  border: 1px solid rgba(106, 27, 154, 0.08);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
}

.co-section-title {
  margin: 0 0 0.35rem;
  font-size: 1.35rem;
  font-weight: 800;
  color: #4a148c;
  letter-spacing: -0.02em;
}

.co-heatmap__desc {
  font-size: 0.9rem;
  color: #616161;
  max-width: 720px;
  line-height: 1.5;
}

.co-heatmap__chart {
  background: #fff;
  border-radius: 16px;
  padding: 0.5rem 0.25rem 0;
  border: 1px solid rgba(0, 0, 0, 0.04);
}
</style>
